import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter: React.FC = () => {
    return (
        <footer className="bg-gray-900 text-gray-400 py-12 text-center border-t border-gray-800 mt-auto">
            <div className="max-w-7xl mx-auto px-4">
                <p>&copy; {new Date().getFullYear()} PocketProf. All rights reserved.</p>
                <div className="mt-4 flex flex-wrap justify-center gap-6">
                    <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
                    <Link to="/terms" className="hover:text-white transition-colors">Terms & AUP</Link>
                    <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
                </div>
                <div className="mt-8 text-sm text-gray-600">
                    <p>Made with ❤️ for teachers everywhere.</p>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;
